import { IBackUrls } from "./back-urls.interface";

export interface IPaymentToSchedule {
  backUrls: IBackUrls;
  advisor: number;
  dealer: number;
  division: number;
  country: string;
  scheduleHour: number;
  scheduleDate: string;
  userName: string;
  vin?: string;
}
